import { registerActions } from "../actionRegistry";
import { getDomElement, setStyle, hide, queryAll } from "../utils/dom";

// REMOVED (2026-08): `loadexpired`, `loadexpiredadmin` and the
// `delegate("click", "[data-imgfile]", …)` that served them.
//
// They were dead, not merely unused. Both functions opened with
// `if (!fromEl || activeEl?.value !== "1") return;` where `fromEl` is
// `#expired_from` — and `#expired_from`, `#expired_active`, `#expired_design`,
// `#expired_target` and `#expadmin` are emitted by NOTHING. Not by any view in
// `apps/pictufy/src/views`, and not by any PHP template in the `legacy-php-final`
// tag either, where `expired_target` appears only inside this very file. So the
// guard returned on every call since before the port.
//
// Corroborating: neither name is in `VIEW_ACTIONS`, so no server-rendered
// `data-fn` reached them; `data-imgfile` was emitted only by those two builders,
// making the delegate unreachable as well; and the `/expired` page was
// reimplemented server-side in `views/pages/Expired.tsx` on a different id scheme
// (`expired-<picId>`, `data-modal="expviewer:…"`) rather than by appending here.
//
// They were ~100 lines of `insertAdjacentHTML` string HTML, so they showed up as
// conversion targets. Converting them would have made unreachable code look
// maintained. `api.reseller.expired` / `api.reseller.expiredAdmin` and their tRPC
// procedures are now caller-less — left in place deliberately, since removing
// server procedures is a separate decision.

/**
 * Filter the payout table rows by the three admin checkboxes.
 *
 * The only live export here: `dashboardpayoutfilter` IS in `VIEW_ACTIONS` and the
 * payout tab emits it via `onChangeCall`. It reads the `mine-`/`warn-`/`bank-`
 * hidden markers that `Dashboard.tsx` renders per row.
 */
export function dashboardpayoutfilter(): void {
  for (const row of queryAll<HTMLElement>(".dashboard-payout-artist")) {
    const raw_id = row.id.replace("artist1-", "");
    let showrow = 1;

    const showMine = getDomElement<HTMLInputElement>("show-mine");
    const showWarn = getDomElement<HTMLInputElement>("show-warn");
    const showBank = getDomElement<HTMLInputElement>("show-bank");

    if (showMine?.checked) {
      if (getDomElement("mine-" + raw_id) === null) {
        showrow = 0;
      }
    }
    if (showWarn?.checked) {
      if (getDomElement("warn-" + raw_id) === null) {
        showrow = 0;
      }
    }
    if (showBank?.checked) {
      if (getDomElement("bank-" + raw_id) === null) {
        showrow = 0;
      }
    }

    if (showrow === 1) {
      setStyle("artist1-" + raw_id, "display", "table-row");
      setStyle("artist2-" + raw_id, "display", "table-row");
    } else {
      hide("artist1-" + raw_id);
      hide("artist2-" + raw_id);
    }
  }
}

registerActions({
  dashboardpayoutfilter,
});
